// import

import {styled} from 'goober';
import type {ComponentProps, ReactChild} from 'react';

import {Type} from 'modules/Type';

// types

type Props = ComponentProps<typeof Styled> & {
  headline: string;
  subhead?: string;
  head?: ReactChild;
  foot?: ReactChild;
};

// component

export function Plaque(props: Props) {
  const {headline, subhead, head, foot, ...rest} = props;

  return (
    <Styled {...rest}>
      <div className="inner">
        <div className="ornament">
          <div className="b1" />
          <div className="b2" />
          <div className="b3" />
        </div>

        <div className="heads">
          {head}
          <Type>
            <h1>{headline}</h1>
            <h2>{subhead}</h2>
          </Type>
          {foot}
        </div>

        <div className="ornament flip">
          <div className="b1" />
          <div className="b2" />
          <div className="b3" />
        </div>
      </div>
    </Styled>
  );
}

// styles

const Styled = styled('aside')`
  width: 100%;
  max-width: var(--bp-ml);

  .inner {
    padding: 0 0.75rem;
    filter:
      drop-shadow(0.75rem 0 var(--yellow-80))
      drop-shadow(-0.75rem 0 var(--yellow-80))
      drop-shadow(0.5rem 0 var(--yellow-70))
      drop-shadow(-0.5rem 0 var(--yellow-70))
      drop-shadow(0.25rem 0 var(--yellow-60))
      drop-shadow(-0.25rem 0 var(--yellow-60));
  }

  .heads {
    background-color: var(--yellow);
    padding: 0 1rem;
    text-align: center;
  }

  h1, h2 { margin: 0; }

  h1 {
    text-transform: uppercase;
    font-weight: 800;
    font-size: 3rem;
  }

  h2 {
    font-weight: 300;
    font-size: 2rem;
  }

  .ornament {
    &.flip { transform: rotate(180deg); }

    div {
      margin: 0 auto;
      position: relative;
      background-color: var(--yellow);
      height: 1.5rem;
      border-radius: 1.5rem 1.5rem 0 0;
    }

    .b1 { width: 50%; }
    .b2 { width: 75%; }
    .b3 { width: 100%; }
  }

  @media (max-width: 44.99875em) {
    h1, h2 { line-height: 2.25rem; }
    h1 { font-size: 2.25rem; }
    h2 { font-size: 1.5rem; }
  }

  @media (max-width: 35.99875em) {
    h2 {
      line-height: 1.625rem;
      font-size: 1.125rem;
    }
  }
`;
